import React from 'react';
import './ProductPopup.css';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ProductPopup = ({ product, fields, dropdownData, onClose, handleEdit, handleDelete, showDelete, showEdit }) => {
  if (!product) return null;

  const renderValue = (key, value) => {
    if (dropdownData[key] && dropdownData[key][value]) {
      return dropdownData[key][value];
    }

    if (Array.isArray(value)) {
      return value.map(item =>
        typeof item === 'object'
          ? item?.name || item?.title || Object.values(item)[1] || JSON.stringify(item)
          : item
      ).join(', ');
    }

    if (typeof value === 'object' && value !== null) {
      return value?.name || value?.title || Object.values(value)[1] || '';
    }

    return value;
  };

  const downloadPdf = async () => {
    const element = document.querySelector(".entryPopup-content");
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: [canvas.width, canvas.height],
    });

    pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
    pdf.save(`Entry-${product._id}.pdf`);
  };

  return (
    <div className="entryPopup-overlay" onClick={onClose}>
      <div className="entryPopup-content" onClick={e => e.stopPropagation()}>
        <div className="entryPopup-header">
          <h2>Entry Details</h2>
          <div className="entryPopup-actions">
            {showEdit && (
              <i
                className="fas fa-pen-to-square entryPopup-edit-icon"
                title="Edit"
                onClick={() => {
                  handleEdit(product._id);
                  onClose();
                }}
              />
            )}
            {showDelete && handleDelete && (
              <i
                className="fas fa-trash entryPopup-delete-icon"
                title="Delete"
                onClick={() => {
                  handleDelete(product._id);
                  onClose();
                }}
              />
            )}
            <i
              className="fas fa-download entryPopup-download-icon"
              title="Download PDF"
              onClick={downloadPdf}
            />
            <button className="entryPopup-close-btn" onClick={onClose}>✖</button>
          </div>
        </div>

        <table className="entryPopup-table">
          <tbody>
            {fields.map(field => (
              <tr key={field.fields}>
                <td className="entryPopup-key">
                  {field.fields.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                </td>
                <td className={`entryPopup-value ${!product[field.fields] ? 'entryPopup-empty' : ''}`}>
                  {renderValue(field.fields, product[field.fields]) || (
                    <i className="fas fa-exclamation-circle" title="This Entry is Missing" />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductPopup;
